/** UI / tab-bar icon imports (multi-density glyphs from assets/icons). */
import archiveAndroid from '~/assets/icons/archive_android.png';
import iconNotificationsFocus from '~/assets/icons/icon_notifications_focus.png';
import iconNotifications from '~/assets/icons/icon_notifications.png';
import iconNotificationsAndroid from '~/assets/icons/icon_notifications_android.png';
import cameraIosFocused from '~/assets/icons/camera_ios_focused.png';
import cameraIos from '~/assets/icons/camera_ios.png';
import cameraAndroid from '~/assets/icons/camera_android.png';
import settingsIosFocused from '~/assets/icons/settings_ios_focused.png';
import settingsIos from '~/assets/icons/settings_ios.png';
import settingsAndroid from '~/assets/icons/settings_android.png';
import selectedAndroid from '~/assets/icons/selected_android.png';
import unselectedAndroid from '~/assets/icons/unselected_android.png';
import deleteIos from '~/assets/icons/delete_ios.png';
import mapHotspotYellow from '~/assets/icons/map_hotspot_yellow.png';
import mapHotspotYellowWhite from '~/assets/icons/map_hotspot_yellow_white.png';
import mapHotspotBlue from '~/assets/icons/map_hotspot_blue.png';
import mapHotspotBlueYellow from '~/assets/icons/map_hotspot_blue_yellow.png';
import mapHotspotWhite from '~/assets/icons/map_hotspot_white.png';
import mapInfoIndicator from '~/assets/icons/mapInfoIndicator.png';
import contactPhone from '~/assets/icons/contact_phone.png';
import contactWeb from '~/assets/icons/contact_web.png';
import play from '~/assets/icons/play.png';

const Icons = {
	archiveAndroid,
	iconNotificationsFocus,
	iconNotifications,
	iconNotificationsAndroid,
	cameraIosFocused,
	cameraIos,
	cameraAndroid,
	settingsIosFocused,
	settingsIos,
	settingsAndroid,
	selectedAndroid,
	unselectedAndroid,
	deleteIos,
	mapHotspotYellow,
	mapHotspotYellowWhite,
	mapHotspotBlue,
	mapHotspotBlueYellow,
	mapHotspotWhite,
	mapInfoIndicator,
	contactPhone,
	contactWeb,
	play,
};

export default Icons;
